export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4080ac171ac55be79b0ec84568e1edb7b76d1936b4&name=revalidateCommunity!'